import React from "react";

export default function Contact() {
  return (
    <div style={{ padding: "50px", textAlign: "center", color: "white" }}>
      <h1>Contact Us</h1>
      <p>You can message us anytime!</p>
    </div>
  );
}
